import * as React from 'react';
import { SimpleForm, TextInput, Title } from 'react-admin';
import { Card, CardContent } from '@mui/material';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';
import { ICreateUserProps } from './types';

const createUserHttp = httpsCallable(functions, 'createUserCall');

interface ICreateUser {
  name: string;
  email: string;
  expoName: string;
}
const createUser = async (ppp: any) => {
  const props = ppp as ICreateUser;
  const data: ICreateUserProps = {
    user: {
      email: props.email,
      // password?: 'string;',
      displayName: props.name,
    },
    customClaims: {
      expo: props.expoName,
      roles: {
        userAdmin: false,
        config: true,
        pushNotifs: true,
        settings: true,
        dataEntry: true,
      },
    },
  };
  console.log('Creating user ', data);
  const res = await createUserHttp(data);
  console.log('Creating user done', res);
};

export const UserCreate = () => (
  <Card>
    <Title title="Create User" />
    <CardContent>
      <SimpleForm onSubmit={createUser}>
        <TextInput source="name" />
        <TextInput source="email" />
        <TextInput source="expoName" />
      </SimpleForm>
    </CardContent>
  </Card>
);
